import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { useSlateStatic } from 'slate-react';
import { Transforms, Editor, Range } from 'slate';
import { Button, Icon, Toolbar } from '../RichTextComp'

const LinkButton = () => {
    const editor = useSlateStatic();
    const [url, setUrl] = useState('');

    const isValidUrl = (value) => {
        try {
            new URL(value);
            return true;
        } catch {
            return false;
        }
    };

    const handleClick = () => {
        const { selection } = editor;
        if (!selection) return;

        // Check if the selection is already a link
        const [linkNode] = Editor.nodes(editor, {
            at: selection,
            match: (n) => n.type === 'link',
        });

        const selectedText = Editor.string(editor, selection);

        // Pre-fill the URL if editing an existing link
        const initialUrl = linkNode ? linkNode[0].url : '';

        const newUrl = prompt('Enter the URL:', initialUrl);

        if (!newUrl) return;

        // if (!isValidUrl(newUrl)) {
        //     alert('Please enter a valid URL (e.g., https://example.com).');
        //     return;
        // }

        setUrl(newUrl);

        if (!linkNode) {
            // Insert a new link
            if (Range.isCollapsed(selection)) {
                // Insert link with URL as text if selection is collapsed
                Transforms.insertNodes(editor, {
                    type: 'link',
                    url: newUrl,
                    children: [{ text: newUrl }],
                });
                // Move cursor outside the link
                Transforms.move(editor, { distance: 1, unit: 'offset' });
                // Insert a space if there's no text following
                const [node] = Editor.node(editor, editor.selection.focus.path);
                if (!node.text) {
                    Transforms.insertText(editor, ' ');
                }
            } else {
                // Wrap selected text in a link
                Transforms.wrapNodes(
                    editor,
                    { type: 'link', url: newUrl, children: [] },
                    { split: true, at: selection }
                );
                Transforms.collapse(editor, { edge: 'end' });
                Transforms.move(editor, { distance: 1, unit: 'offset' });
                const [node] = Editor.node(editor, editor.selection.focus.path);
                if (!node.text) Transforms.insertText(editor, ' ');
            }
        } else {
            // Update existing link
            Transforms.setNodes(
                editor,
                { url: newUrl },
                { match: (n) => n.type === 'link' }
            );
        }
    };

    return (
        <Button onMouseDown={handleClick}>
            <Tooltip title="Insert Link" arrow>
                <Icon>link</Icon>
            </Tooltip>
        </Button>
    );
};

export default LinkButton;
